module.exports = __webpack_public_path__ + "media/login-page-bg-rzd-1366@2x.513621b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/login-page-bg-rzd-1366@2x.jpg
// module id = 1256
// module chunks = 58